import { useEffect } from 'react';
import { useField } from 'informed';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';

// import { generateActualValidate } from './utility';

// types and classes
import type { $TSFixMe } from '@calefy-inc/utilityTypes';

// @ts-expect-error
const generateActualValidate = (required, validate) => {
  return required ? validate : () => undefined;
}
interface InformedTextFieldProps {
  name: string;
  label?: $TSFixMe;
  helperText?: $TSFixMe;
  defaultValue?: $TSFixMe;
  classes?: $TSFixMe;
  className?: $TSFixMe;
  validate?: $TSFixMe;
  required?: $TSFixMe;
  validateOnChange?: $TSFixMe;
  variant?: $TSFixMe;
  onBlur?: $TSFixMe;
  [k: string]: $TSFixMe;
}
export const InformedTextField = (props: InformedTextFieldProps) => {
  const {
    helperText,
    defaultValue,
    // eslint-disable-next-line no-unused-vars
    classes = {},
    name,
    label,
    className,
    validate,
    required,
    // eslint-disable-next-line no-unused-vars
    validateOnChange = true,
    variant = 'standard',
    onBlur: passedInOnblur,
    keepState,
    ...otherProps
  } = props;

  const labelLength = label ? label.length : 0;
  const actualValidate = generateActualValidate(required, validate);

  const {
    fieldState,
    fieldApi,
    render,
    ref,
    userProps,
    // @ts-expect-error
    keepState: informedKeepState,
    ...rest
  } = useField({
    ...props,
    validate: actualValidate,
  });

  const { value } = fieldState;
  const { setValue, setTouched, setError } = fieldApi;
  // @ts-expect-error - userProps typing issue from informed library
  const { onChange, onBlur } = userProps;

  //set the value
  useEffect(() => {
    if (props.value !== undefined) {
      setValue(String(props.value));
    } else if (
      (value === undefined || value === '') &&
      defaultValue !== undefined
    ) {
      setValue(defaultValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue, props.value]);

  //set the error, if provided as a prop
  useEffect(() => {
    if (props.error === true) {
      setError(props.helperText ? props.helperText : 'Error');
    } else if (props.error === false) {
      setError(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.error]);

  // if the field is in an error state, display text: fieldState.error (or helpText as a fallback). Otherwise, don't display anything
  let actualHelperText;
  if (props.error || fieldState.error) {
    actualHelperText = fieldState.error ? String(fieldState.error) : props.helperText;
  } else {
    actualHelperText = undefined;
  }

  return render(
    <>
      <FormControl
        variant={variant}
        className={className}
        error={!!fieldState.error}
        {...otherProps}
      >
        <>
          {labelLength >= 80 ? (
            <FormLabel htmlFor={name}>{label}</FormLabel>
          ) : null}
          <TextField
            {...rest}
            variant={variant}
            label={labelLength <= 79 ? label : null}
            value={value ?? ''}
            name={name}
            id={name}
            ref={ref}
            disabled={props.disabled}
            //default to the prop; otherwise the formstate
            error={props.error === undefined ? !!fieldState.error : props.error}
            helperText={actualHelperText}
            onChange={(e) => {
              setValue(e.target.value);
              if (onChange) {
                onChange(e);
              }
            }}
            onBlur={(e) => {
              setTouched(true);
              if (onBlur) {
                onBlur(e);
              }
            }}
          />
        </>
      </FormControl>
    </>,
  );
};
